// ============================================================
// Карго админ — дизайн токенууд (нэг эх сурвалж).
// Бүх шинэ primitive болон AdminLayout эндээс өнгө/үсэг/радиусаа авна.
// @mui/styles-аас хамааралгүй — зөвхөн энгийн утгууд.
// ============================================================

export const tokens = {
  color: {
    ink: "#16243B",
    ink2: "#1E3050",
    ink3: "#27395B",
    canvas: "#EEF2F6",
    surface: "#FFFFFF",
    line: "#E4E9F0",
    line2: "#EEF2F7",
    text: "#1E293B",
    muted: "#64748B",
    muted2: "#94A3B8",

    brand: "#0D9488",
    brandDark: "#0B7C72",
    brandSoft: "#E6F4F2",

    amber: "#D97706",
    amberSoft: "#FDF1E1",
    green: "#16A34A",
    greenSoft: "#E7F5EC",
    slate: "#64748B",
    slateSoft: "#EEF1F5",
    red: "#DC2626",
    redSoft: "#FBEAEA",

    sidebarBorder: "#243653",
  },
  font: {
    display: '"Manrope","Inter",system-ui,sans-serif',
    body: '"Inter",system-ui,sans-serif',
  },
  radius: { lg: 14, md: 10, sm: 8, xs: 6, pill: 30 },
  shadow: {
    sm: "0 1px 2px rgba(16,36,60,.06)",
    md: "0 4px 16px rgba(16,36,60,.08)",
    lg: "0 18px 48px rgba(16,36,60,.18)",
  },
  layout: { sidebar: 264, sidebarCollapsed: 74, topbar: 70 },
};

// Аяллын төлөв (location) → дараалал ба харагдах нэр.
// DB-ийн утга ("Ачигдсан", "Монголд") хэвээр — зөвхөн харагдах нэр нь Хөвсгөл салбарт тохирсон.
export const JOURNEY_STEPS = ["Эрээнд", "Ачигдсан", "Монголд"];
export const LOCATION_LABELS = {
  "Эрээнд": "Эрээнд",
  "Ачигдсан": "Хөвсгөл рүү ачигдсан",
  "Монголд": "Хөвсгөлд ирсэн",
};
// Дараагийн алхам (төлөв ахиулахад)
export const NEXT_LOCATION = { "Эрээнд": "Ачигдсан", "Ачигдсан": "Монголд" };
export const locationLabel = (loc) => LOCATION_LABELS[loc] || loc || LOCATION_LABELS["Монголд"];

export const journeyIndex = (loc) => {
  const i = JOURNEY_STEPS.indexOf(loc);
  // Тодорхойгүй/хоосон бол Монголд гэж үзнэ (гараар бүртгэсэн хуучин дата)
  return i === -1 ? JOURNEY_STEPS.length - 1 : i;
};

export default tokens;
